require('./brokerConfigCustomItem.scss');

const PropTypes = require('prop-types');

// @utils
const { getPreConditionText } = require('utilities/brokerAlertsConditionTextHelper');

// @vendors
const React = require('react');
const classNames = require('classnames');

// @constants
const { EURO_SYMBOL,
        BROKER_ALERT_FRACTION_LENGTH_EURO_VALUE,
        BROKER_IBEX35_STOCK_MARKET_NAME,
        BROKER_ALERT_CONFIGURATION_POINTS_NAME,
        BROKER_TYPE_STOCKS_NEW_DECIMALS,
        IBEX35_TEXT,
        BROKER_ALERT_FRACTION_LENGTH_PERCENTAGE_VALUE,
        PERCENTAGE_SYMBOL,
} = require('constants/index');

// @components
const { OKIconButton } = require('commonsComponents/OKIconButton');

// @ commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @helpers
const { formatAmount } = require('utilities/currencyHelper');

class BrokerConfigCustomItem extends React.Component {
    constructor(props) {
        super(props);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    handleDelete() {
        this.props.onHandleDelete(this.props.immItem);
    }

    handleEdit() {
        this.props.onHandleEdit(this.props.immItem);
    }

    render() {
        const { id, immItem, editing } = this.props;

        if (immItem.get('isRemoving')) {
            return null;
        }

        const percentageConditionsIds = ['VMN', 'VMY', 'BDV', 'SDV'];
        const isConfigIbex35 = immItem.get('instrument') === IBEX35_TEXT;
        const text = getPreConditionText(immItem.get('conditionId'), isConfigIbex35);
        let stateActiveText;

        // (Andres): The conditionName sent by the service has the followin format "Cotizacion menor o giual a (EURO)"
        // or "Prcentaje de bajada diaria mayor de (%)"
        // What we need to do here is replace the (EURO) or (%) for the actual number
        if ( percentageConditionsIds.indexOf(immItem.get('conditionId')) === -1 ){
            let conditionValue = formatAmount(immItem.get('conditionValue'), undefined, BROKER_ALERT_FRACTION_LENGTH_EURO_VALUE);

            if (immItem.get('instrument') === BROKER_IBEX35_STOCK_MARKET_NAME) {

                stateActiveText = text.replace(/\((.+)\)/, `${conditionValue} ${BROKER_ALERT_CONFIGURATION_POINTS_NAME}`);
            } else {
                conditionValue = formatAmount(immItem.get('conditionValue'), undefined, BROKER_TYPE_STOCKS_NEW_DECIMALS);
                stateActiveText = text.replace(/\((.+)\)/, conditionValue + EURO_SYMBOL);
            }
        } else {
            const conditionValue = formatAmount(immItem.get('conditionValue'), undefined, BROKER_ALERT_FRACTION_LENGTH_PERCENTAGE_VALUE);
            stateActiveText = text.replace(/\((.+)\)/, conditionValue + PERCENTAGE_SYMBOL);
        }

        const btnEditId = `btnEdit_${id}`;
        const btnRemoveId = `btnRemove_${id}`;
        const tooltipOffsetX = 0;
        const tooltipOffsetY = -35;

        let editButton;

        if (!editing) {
            const tooltipEditTarget = (
                <span>
                    <OKIconButton
                        size="small"
                        icon="icon-editar"
                        id={btnEditId}
                        onClick={this.handleEdit}
                    />
                </span>
            );

            editButton = (
                <OKTooltip
                    content="configCustomItem-edit"
                    offset={[tooltipOffsetX, tooltipOffsetY]}
                    target={tooltipEditTarget}
                    type="descriptive"
                />
            );
        }

        const customItemClass = classNames('broker-config-custom-item', {
            'broker-config-custom-item--highlighted': editing
        });

        const tooltipDeleteTarget = (
            <span>
                <OKIconButton
                    icon="icon-eliminar"
                    id={btnRemoveId}
                    size="small"
                    onClick={this.handleDelete}
                />
            </span>
        );

        return (
            <div id={id} className={customItemClass}>
                <span className="broker-config-custom-item__name">
                    {immItem.get('instrument')}
                    , {stateActiveText}
                </span>
                <div className="broker-config-custom-item__button-group">
                    {editButton}
                    <OKTooltip
                        content="configCustomItem-delete"
                        offset={[tooltipOffsetX, tooltipOffsetY]}
                        target={tooltipDeleteTarget}
                        type="descriptive"
                    />
                </div>
            </div>
        );
    }
}

BrokerConfigCustomItem.propTypes = {
    id: PropTypes.string,
    immItem: PropTypes.object.isRequired,
    onHandleEdit: PropTypes.func.isRequired,
    onHandleDelete: PropTypes.func.isRequired,
    editing: PropTypes.bool.isRequired
};

module.exports = BrokerConfigCustomItem;
